export default __webpack_public_path__ + "static/media/canxium-logo.01d63ba5.png";